// removed by extract-text-webpack-plugin
module.exports = {"base":"InfoTip_base--E_p6x","isOpened":"InfoTip_isOpened--1Ir1y","overlay":"InfoTip_overlay--2Cnke","infotip":"InfoTip_infotip--2iP-g","close":"InfoTip_close--3S77T","inner":"InfoTip_inner--1b0-V","bgElement":"InfoTip_bgElement--3dVFX","header":"InfoTip_header--Hakdo","body":"InfoTip_body--2ve5f","isScrollEnabled":"InfoTip_isScrollEnabled--p7yTA","content":"InfoTip_content--2cIhP"};


//////////////////
// WEBPACK FOOTER
// ../node_modules/react-wot-bootstrap/lib/components/InfoTip/InfoTip.css
// module id = 1786
// module chunks = 16